import fan from '../services/fan';

export default (url, axiosOptions = {}) =>
  fan.get(url, axiosOptions).then(response => {
    const { status, data, headers } = response;

    return { status, headers: new Headers(headers), body: data, json: data };
  });
